import { ActionTypes } from '../utils/constants';

/**
 * Fetch reservation request
 * @param {Object} reservationId
 * @returns {Object}
 */
export function fetchReservationRequest(reservationId) {
  return {
    type: ActionTypes.FETCH_RESERVATION_REQUEST,
    payload: { reservationId },
  };
}

/**
 * Fetch reservation success
 * @param {Object} reservation
 * @returns {Object}
 */
export function fetchReservationSuccess(reservation) {
  return {
    type: ActionTypes.FETCH_RESERVATION_SUCCESS,
    payload: { reservation },
  };
}

/**
 * Fetch reservation failure
 * @returns {Object}
 */
export function fetchReservationFailure() {
  return {
    type: ActionTypes.FETCH_RESERVATION_FAILURE,
  };
}

/**
 * Fetch reservation reset
 * @returns {Object}
 */
export function fetchReservationReset() {
  return {
    type: ActionTypes.FETCH_RESERVATION_RESET,
  };
}

export function sendCotizacion(tipo,
  modelo,
  version,
  anio,
  color,
  cotizacion) {
  return {
    type: ActionTypes.SEND_COTIZACION_REQUEST,
    payload: {
      tipo,
      modelo,
      version,
      anio,
      color,
      cotizacion,
    },
  };
}

export function sendCotizacionSuccess() {
  return {
    type: ActionTypes.SEND_COTIZACION_SUCCESS,
  };
}